export const chapters = ['Chapter 7', 'Chapter 11', 'Chapter 12', 'Chapter 13'];
